<template>
  <b-card class="information-container" :title="$t('driver information') | capitalize">
    <div class="container-info">
      <div class="information">
        <div class="text-secondary"> {{ $t('driver code') | capitalize}}</div>
        <b-badge variant="light-warning">
          {{ user.code }}
        </b-badge>
      </div>
      <div class="information">
        <div class="text-secondary">{{ $t('Viatic') }}</div>
        <b-badge :variant="user.is_viatic === 'Apply' ? 'light-success' : 'light-danger'">
            {{ user.is_viatic }}
        </b-badge>
      </div>
      <div class="information">
        <div class="text-secondary">{{ $t('Entity Group') }}</div>
        <div class="text-dark">
          {{ user.entity_group ? user.entity_group : "Por agregar" }}
        </div>
      </div>
    </div>
  </b-card>
</template>
  
  <script>
import UserService from "@/views/users/services/users.service.js";
export default {
  props: {
    employeeId: {
      type: Number,
      requred: true,
    },
  },

  data() {
    return {
      user: {},
    };
  },

  methods: {
    async getUserProfile() {
      const params = {
        employee_id: this.employeeId,
      };

      const { data } = await UserService.getDriverInformation(params);
      this.user = data[0];
    },
  },

  mounted() {
    this.getUserProfile();
  },
};
</script>
  
  <style scoped lang="scss">
.information-container {
  width: 100%;
  border-radius: 20px;
}

.container-img {
  width: 100%;
  height: 40%;
  display: flex;
  align-items: center;
  justify-content: start;
  flex-direction: column;
  border-bottom: 1px solid #e3e4e8;
}

.container-info {
  width: 100%;
  height: 60%;
  padding: 0 10px;
}

.information {
  margin: 10px 0;
}
</style>